import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Chip,
  Grid,
  // FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import { useEffect, useState } from 'react';

export default function EditLeadModal({ open, onClose, leadData, onSave, leadScoreGenLoading }) {
  // Initialize form state with default empty fields or leadData
  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    jobTitle: '',
    industry: '',
    companySize: '',
    website: '',
    phone: '',
    linkedin: '',
    country: '',
    state: '',
    city: '',
    status: 'new',
    tags: [],
    ...leadData,
  });

  const [newTag, setNewTag] = useState('');
  const [errors, setErrors] = useState({});

  // Sync form state when leadData changes
  useEffect(() => {
    setForm({
      firstName: '',
      lastName: '',
      email: '',
      company: '',
      jobTitle: '',
      industry: '',
      companySize: '',
      website: '',
      phone: '',
      linkedin: '',
      country: '',
      state: '',
      city: '',
      status: 'new',
      tags: [],
      ...leadData,
    });
    setNewTag('');
    setErrors({});
  }, [leadData]);

  // Validation function
  const validate = (updatedForm = form) => {
    const newErrors = {};

    if (!updatedForm.firstName?.trim()) newErrors.firstName = 'First Name is required';
    if (!updatedForm.lastName?.trim()) newErrors.lastName = 'Last Name is required';
    if (!updatedForm.email?.trim()) newErrors.email = 'Email is required';
    else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(updatedForm.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!updatedForm.company?.trim()) newErrors.company = 'Company is required';
    if (!updatedForm.jobTitle?.trim()) newErrors.jobTitle = 'Job Title is required';
    if (!updatedForm.industry?.trim()) newErrors.industry = 'Industry is required';
    if (!updatedForm.companySize?.trim()) newErrors.companySize = 'Company Size is required';
    if (!updatedForm.website?.trim()) newErrors.website = 'Website is required';
    if (!updatedForm.phone?.trim()) newErrors.phone = 'Phone is required';
    if (!updatedForm.linkedin?.trim()) newErrors.linkedin = 'LinkedIn is required';
    if (!updatedForm.country?.trim()) newErrors.country = 'Country is required';
    if (!updatedForm.state?.trim()) newErrors.state = 'State is required';
    if (!updatedForm.city?.trim()) newErrors.city = 'City is required';

    if (!updatedForm.status) newErrors.status = 'Status is required';

    if (!updatedForm.tags || updatedForm.tags.length === 0) {
      newErrors.tags = 'At least one tag is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...form, [name]: value };
    setForm(updatedForm);

    validate(updatedForm);
  };

  // Add a new tag
  const handleAddTag = () => {
    const tag = newTag.trim();
    if (
      tag &&
      !form.tags.includes(tag) &&
      (form.tags.length < 5)
    ) {
      const updatedTags = [...form.tags, tag];
      const updatedForm = { ...form, tags: updatedTags };
      setForm(updatedForm);
      validate(updatedForm);
    }
    setNewTag('');
  };

  // Handle Enter key to add tag
  const handleTagKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };

  // Delete a tag
  const handleDeleteTag = (tagToDelete) => {
    const updatedTags = form.tags.filter((tag) => tag !== tagToDelete);
    const updatedForm = { ...form, tags: updatedTags };
    setForm(updatedForm);
    validate(updatedForm);
  };

  // Handle form submission
  const handleSubmit = () => {
    if (validate()) {
       console.log('Saving form data with tags:', form.tags);
      onSave(form);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm"
     slotProps={{ paper :{
          sx: {
            borderRadius: 2,  
          },
        } 
    }}
    >
      <DialogTitle>Edit Lead</DialogTitle>

      {/* {!leadScoreGenLoading ? ( */}
        <>
          <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Form Fields Grid */}
            <Grid container spacing={2}>
              {[
                { name: 'firstName', label: 'First Name', maxLength: 100 },
                { name: 'lastName', label: 'Last Name', maxLength: 100 },
                { name: 'email', label: 'Email', maxLength: 100 },
                { name: 'company', label: 'Company', maxLength: 100 },
                { name: 'jobTitle', label: 'Job Title', maxLength: 100 },
                { name: 'industry', label: 'Industry', maxLength: 100 },
                { name: 'companySize', label: 'Company Size', maxLength: 30 },
                { name: 'website', label: 'Website URL', maxLength: 300 },
                { name: 'phone', label: 'Phone', maxLength: 13 },
                { name: 'linkedin', label: 'LinkedIn URL', maxLength: 300 },
                { name: 'city', label: 'City', maxLength: 100 },
                { name: 'state', label: 'State', maxLength: 100 },
                { name: 'country', label: 'Country', maxLength: 100 },
              ].map(({ name, label, maxLength }) => (
                <Grid size={{xs:12, sm:6}}  key={name}>
                  <TextField
                    name={name}
                    label={label}
                    value={form[name] || ''}
                    onChange={handleChange}
                    error={!!errors[name]}
                    helperText={errors[name]}
                    size="small"
                    fullWidth
                    slotProps={{ htmlInput: { maxLength } }}
                  />
                </Grid>
              ))}

              {/* Status */}
              <Grid size={{xs:12, sm:6}}>
                {/* <FormControl fullWidth size="small" error={!!errors.status}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    name="status"
                    label="Status"
                    value={form.status || ''}
                    onChange={handleChange}
                  >
                    <MenuItem value="new">New</MenuItem>
                    <MenuItem value="contacted">Contacted</MenuItem>
                    <MenuItem value="converted">Converted</MenuItem>
                  </Select>
                </FormControl> */}
              </Grid>

              {/* Tags Field */}
              <Grid size={{xs:12, sm:12}}>
                <TextField
                  label={form.tags.length >= 5 ? "Maximum 5 tags per lead" : "Tags"}
                  placeholder="Type Tag Name and Press Enter"
                  fullWidth
                  size="small"
                  value={newTag}
                  onChange={(e) => setNewTag(e.target.value)}
                  onKeyDown={handleTagKeyDown}
                  disabled={form.tags.length >= 5}
                  error={!!errors.tags}
                  helperText={errors.tags}
                  slotProps={{ htmlInput: { maxLength: 30 } }}
                />
                <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                  {form.tags.map((tag) => (
                    <Chip
                      key={tag}
                      label={tag}
                      size="small"
                      onDelete={() => handleDeleteTag(tag)}
                      onMouseDown={(e) => e.stopPropagation()} // prevent dropdown if inside Select
                      color="primary"
                    />
                  ))}
                </Box>
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={onClose} color="inherit">Cancel</Button>
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={
                Object.keys(errors).length > 0 ||
                !form.firstName ||
                !form.lastName ||
                !form.email ||
                !form.company ||
                !form.jobTitle ||
                !form.industry ||
                !form.companySize ||
                !form.website ||
                !form.phone ||
                !form.linkedin ||
                !form.country ||
                !form.state ||
                !form.city ||
                !form.status ||
                form.tags.length === 0
              }
            loading={leadScoreGenLoading}
            loadingPosition='end'
            >
              {leadScoreGenLoading ? 'Saving...' : 'Save'}
            </Button>
          </DialogActions>
        </>
      {/* ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', p: 2, m: 2 }}>
          <CircularProgress />
          <Typography variant="body1" sx={{ mx: 4 }}>Updating lead info...</Typography>
        </Box>
      )} */}
    </Dialog>
  );
}
